export const errorHandler = (formInstance, errors) => {
  formInstance.formInstance = false
  formInstance.hasUnknownError = false
  formInstance.hasError = false

  errors.forEach(error => {
    /*
      Fehlerbehandlung für Errors, die keine errorExtension auf dem
      Server zurückgeben -> Unbekannte Fehler
    */
    if (!error.extensions || !error.extensions.errorType) {
      formInstance.hasUnknownError = true
      formInstance.unknownErrorMessage = formInstance.$t('formError.unknownwError')
      return
    }

    const { fieldName, i18n, errorType } = error.extensions

    /*
      Fehlerbehandlung für Errors die spezifisch sind aber nicht auf ein Feld gemappt werden
      Erscheinen als alert über dem Form
    */
    if (errorType === 'InvalidCredentials' || errorType === 'TokenError' || errorType === 'ReferencedDependencyError') {
      formInstance.hasError = true
      formInstance.errorMessage = formInstance.$t(`formError.${i18n}`)
      return
    }

    /*
      Fehlerbehandlung für Errors, die auf ein spezifisches Formfeld gemappt werden
    */
    if (errorType === 'UserInputError') {
      formInstance.$refs.observer.setErrors({
        [fieldName]: [formInstance.$t(`formError.${i18n}`)]
      })
      return
    }

    formInstance.hasUnknownError = true
    formInstance.unknownErrorMessage = formInstance.$t('formError.unknownwError')
  })
}

export const validateField = (valid, errors, changed) => {
  if (!changed && !errors[0]) {
    return null
  }

  return errors[0] ? false : null
}
